import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Logo from '../Yavrio-CMYK.svg';

const HomePage = () => {
    return (
        <Box sx={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "#f5f5f5"
        }}>
            <Container maxWidth="sm">
                <Box sx={{ textAlign: "center" }}>
                    <img src={Logo} alt="Yavrio Logo" style={{ height: 80, marginBottom: 32 }} />

                    <Box sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 1,
                        mb: 2
                    }}>
                        <InfoOutlinedIcon sx={{ color: "primary.main", fontSize: 28 }} />
                        <Typography variant="h5" color="primary.main" sx={{ fontWeight: 500 }}>
                            Payment Link Required
                        </Typography>
                    </Box>

                    <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 400, mx: "auto" }}>
                        Please make sure to copy the complete payment URL.
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default HomePage;
